import React from "react";
import Header from "../components/HeaderThree";
import "../styles/UpcomingProject.css";

export default function UpcomingProjectPage({ title, logo, backgroundImage }) {
  const heroStyle = backgroundImage
    ? { "--upcoming-bg": `url(${backgroundImage})` }
    : undefined;

  return (
    <section className="upcoming-project-page">
      <Header />
      <div className="upcoming-hero" style={heroStyle}>
        <div className="upcoming-hero__content container">
          {logo ? (
            <img
              src={logo}
              alt={`${title} logo`}
              className="upcoming-hero__logo"
            />
          ) : null}
          <p className="upcoming-hero__eyebrow">Upcoming Project</p>
          <h1 className="upcoming-hero__title">{title}</h1>
          <p className="upcoming-hero__message">
            Working on it. This is an upcoming project. You will get updates very soon.
          </p>
        </div>
      </div>
    </section>
  );
}
